export default __webpack_public_path__ + "static/media/noCollected.8fdc3d21.svg";